export default "__VITE_ASSET__DWdgI7SS__"